import React from "react";
import ImageButton from "./ImageButton";
import PropTypes from "prop-types";
import { CSCContext } from "../CSCContext";

class ImageButtonGrid extends React.Component {
	static contextType = CSCContext;

	onClick = (e) => {
		this.context.setUserData(this.props.name, e.target.value);
		this.context.onImageButtonClick();
	}

	render() {
		return (
			<div id={this.props.name} className="image-button-grid">
				{this.props.buttons.map((button) => {
					return (
						<ImageButton
							key={button.value}
							name={button.name}
							value={button.value}
							text={button.text}
							image={button.url}
							onClick={this.onClick}
						></ImageButton>
					);
				})}
			</div>
		);
	}
}

ImageButtonGrid.propTypes = {
	name: PropTypes.string.isRequired,
	buttons: PropTypes.array.isRequired,
};

export default ImageButtonGrid;
